import React, { useState } from "react";
import { TopBanner } from "./TopBanner";
import { MenuToggle } from "./components/MenuToggle";
import { ZedXMainMenu } from "./components/ZedXMainMenu";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { buildZedXMainAppBreadcrumb } from "./breadcrumbs";
import { useLocation, useNavigate, Routes, Route } from "react-router-dom";
import { AppGlobals } from "./AppGlobals";
import { CustomerAccessPanel } from "./components/account/CustomerAccessPanel";

export const Home: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const [isNavigationVisible, setNavigationVisible] = useState(false);
    const getInitialEnvironment = (): "LIVE" | "TEST" => {
        const lastEnv = localStorage.getItem("lastEnvironment");
        return lastEnv === "TEST" ? "TEST" : "LIVE";
    };

    const [environment, setEnvironment] = useState<"LIVE" | "TEST">(getInitialEnvironment);
    const toggleNavigation = () => setNavigationVisible(!isNavigationVisible);

    const breadcrumbItems = buildZedXMainAppBreadcrumb();

    return (
        <ErrorBoundary>
            <div className="main">
                <div className="container">

                    {/* LEFT NAVIGATION */}
                    <div className={`navigation ${isNavigationVisible ? 'show' : ''}`}>
                        <ZedXMainMenu
                            environment={environment}
                            onEnvironmentChange={setEnvironment}
                            onCloseMenu={() => setNavigationVisible(false)}
                        />
                    </div>

                    {/* BACKDROP */}
                    <div
                        className={`nav-backdrop ${isNavigationVisible ? 'show' : ''}`}
                        onClick={toggleNavigation}
                        aria-hidden={!isNavigationVisible}
                    />

                    {/* RIGHT CONTENT AREA */}
                    <div className="right-area">
                        <div className="top-banner">
                            <MenuToggle onToggleNavigation={toggleNavigation} />
                            <TopBanner breadcrumbItems={breadcrumbItems} />
                        </div>

                        <div className="content">
                            <Routes>
                                <Route path="/"
                                    element={
                                        <CustomerAccessPanel
                                            key={environment}
                                            environment={environment}
                                        />
                                    } />
                            </Routes>
                        </div>
                    </div>

                </div>
            </div>
        </ErrorBoundary>
    );
};